import React from "react";
import LkDeliveryTableEl from "./LkDeliveryTableEl";

const LkDeliveryTable = (props) => {
    const DeliveryCard = props.data.LkDelivery.DeliveryCard;
    return (
        <div className="h-[93%] py-[24px]">
            <div className="h-[100%] bg-[#fff] rounded-[20px] p-[15px] xl:py-[24px] xl:px-[30px]">

                {/* Заголовки таблицы */}
                <div className="grid grid-cols-8 gap-[10px]  xl:text-[14px] text-[12px] pb-[16px] border-b-[2px] border-solid"
                style={{
                    borderColor: DeliveryCard.color1,
                    color: DeliveryCard.color2
                }}>
                    <div>{DeliveryCard.text9}</div>
                    <div>{DeliveryCard.text10}</div>
                    <div>{DeliveryCard.text2}</div>
                    <div>{DeliveryCard.text3}</div>
                    <div>{DeliveryCard.text11}</div>
                    <div>{DeliveryCard.text6}</div>
                    <div>{DeliveryCard.text7}</div>
                    <div>{DeliveryCard.text8}</div>
                </div>

                <div className="h-full overflow-y-auto hide-scrollbar">
                    
                    {
                        props.orderList.map((el, index)=>(
                            <LkDeliveryTableEl data={props.data} el={el} key={index}/>
                        ))
                    }
                </div>
                
            </div>
        </div>
    );
}

export default LkDeliveryTable;
